var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdited(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5L7.793 1.293C7.60551 1.10545 7.35119 1.00006 7.086 1H3C2.73478 1 2.48043 1.10536 2.29289 1.29289C2.10536 1.48043 2 1.73478 2 2V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H9C9.26522 11 9.51957 10.8946 9.70711 10.7071C9.89464 10.5196 10 10.2652 10 10",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.689 6.313C10.8882 6.11382 11.0001 5.84368 11.0001 5.562C11.0001 5.28032 10.8882 5.01018 10.689 4.811C10.4898 4.61182 10.2197 4.49992 9.93799 4.49992C9.65631 4.49992 9.38617 4.61182 9.18699 4.811L7.18199 6.817C7.06311 6.93581 6.9761 7.08267 6.92899 7.244L6.51049 8.679C6.49794 8.72202 6.49719 8.76763 6.50831 8.81104C6.51943 8.85446 6.54202 8.89408 6.57371 8.92577C6.6054 8.95746 6.64503 8.98005 6.68844 8.99118C6.73186 9.0023 6.77746 9.00155 6.82049 8.989L8.25549 8.5705C8.41682 8.52339 8.56368 8.43637 8.68249 8.3175L10.689 6.313Z",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9H4.5",
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdited);
export default __webpack_public_path__ + "static/media/edited.ed50a649b32d1fbf3a782d6346b7395d.svg";
export { ForwardRef as ReactComponent };